export const CATEGORY_MAP = [
  // Long
  {
    code: "Equity",
    label: "Equity",
  },
  {
    code: "F&O",
    label: "F&O",
  },
  {
    code: "Swap",
    label: "Swaps",
  },
  {
    code: "Bonds",
    label: "Fixed Income",
  },
  {
    code: "Unlisted asset / Private Equity",
    label: "PE/Unlisted",
  },
  {
    code: "Public Funds",
    label: "Public Funds",
  },
  // {
  //   code: 'Depository Receipt',
  //   label: 'Depository Receipt'
  // },
  {
    code: "Other Derivatives",
    label: "Other Derivatives",
  },
];
